import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { useAuth } from '../auth';

type Props = Readonly<{
  children?: ReactNode;
}>;

const AccessGuardian = ({ children }: Props) => {
  const auth = useAuth();
  const location = useLocation();

  if (!auth.user) {
    return (
      <Navigate
        to={'/authenticate' + location.search}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default AccessGuardian;
